<template>
  <div>
    <v-icon @click="onClickButton(urlPath, permission)">{{
      getIconName(permission)
    }}</v-icon>
  </div>
</template>

<script>
import editOrViewCheck from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/editOrViewCheck'
import getIconNameFromMode from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/getIconNameFromMode'
import { actions } from '@/vuex/modules/pointGroupOperation/constants'
export default {
  name: 'EditOrViewButton',
  props: {
    permission: {
      type: String,
      default: () => '',
    },
    urlPath: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    getIconName(permission) {
      return getIconNameFromMode(editOrViewCheck(permission))
    },
    onClickButton(urlPath, permission) {
      this.$store.dispatch(actions.SET_PAGE_PERMISSION, {
        pagePermission: permission,
      })
      this.$router.push(urlPath).catch(() => {})
    },
  },
}
</script>

<style scoped></style>
